import React from 'react';
import { format } from 'date-fns';

/**
 * Componente específico para exibir um evento no calendário em dispositivos móveis.
 * Versão simplificada e otimizada para espaços pequenos.
 * 
 * @param {Object} props - Propriedades do componente
 * @param {Object} props.event - Dados do evento
 * @param {Function} props.onSelect - Função chamada quando o evento é selecionado
 * @returns {JSX.Element} - Elemento React
 */
const MobileTimelineEvent = ({ event, onSelect }) => {
  // Verificar se o evento existe
  if (!event) return null;
  
  // Garantir que appointment existe
  const appointment = event.appointment || {};
  
  // Mostra apenas o horário de início para economizar espaço
  let timeString = '';
  try {
    timeString = event.start ? format(event.start, 'HH:mm') : '';
  } catch (error) {
    console.error('Erro ao formatar horário:', error);
  }
  
  // Função para lidar com cliques no evento
  const handleEventClick = (e) => {
    e.stopPropagation(); // Impedir propagação de eventos
    
    // Se onSelect foi fornecido, chamar com o evento de DOM e os dados do evento
    if (typeof onSelect === 'function') {
      onSelect({
        ...event,
        currentTarget: e.currentTarget // Passar o elemento atual para capturar posição
      });
    }
  };
  
  // Função para lidar com teclas (acessibilidade)
  const handleKeyPress = (e) => {
    // Abrir ao pressionar Enter ou Espaço
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      
      if (typeof onSelect === 'function') {
        onSelect({
          ...event,
          currentTarget: e.currentTarget // Passar o elemento atual para capturar posição
        });
      }
    }
  };

  // Determinando status para exibição (simplificado)
  const isNoShow = !!appointment.noShow;
  const isCanceled = appointment.status === 'canceled' || !!appointment.cancelado;

  // Em dispositivos móveis, optamos por uma versão super minimalista do card
  return (
    <div 
      className="mobile-event-wrapper w-full h-full p-0"
      role="button"
      tabIndex={0}
      onClick={handleEventClick}
      onKeyPress={handleKeyPress}
      aria-label={`Agendamento: ${event.title || ''} - ${timeString}`}
    >
      <div className="mobile-event-content">
        <div className="event-time">
          {timeString}
        </div>
        <div className="event-status">
          {isNoShow ? "No-show" : isCanceled ? "Cancelado" : ""}
        </div>
      </div>
    </div>
  );
};

export default MobileTimelineEvent; 